import { Observable, of, map } from 'rxjs';
import {
  SMEDisciplineInObservationViewModel,
  SMEDisciplineAssignments,
} from '../models/autogenerated';
import { UserDataService } from 'src/app/core/services/user-data.service';

export function getObservationToolDisciplineAndSMEAssignedObservable(
  smeDiscipline: SMEDisciplineInObservationViewModel,
  userDataService: UserDataService,
  getDisciplineCode: boolean = false
): Observable<string> {
  if (!smeDiscipline) {
    return of('');
  }
  const name = getDisciplineCode
    ? smeDiscipline.disciplineCode
    : smeDiscipline.name;
  const assignments = smeDiscipline.assignments;
  const primarySMEUserId = assignments?.find(
    (x) => x.label === SMEDisciplineAssignments.PrimarySME
  )?.userId;

  if (!primarySMEUserId) {
    return of(name);
  }

  return userDataService
    .getUserNameByOid(primarySMEUserId)
    .pipe(map((userName) => `${name} - ${userName}`));
}
